<template>
  <div>{{ timeLeftText }}</div>
</template>

<script>
  export default {
    props: {
      milliseconds: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        timer: null,
        timeLeft: this.milliseconds
      }
    },
    computed: {
      timeLeftText () {
        const date = new Date(null)
        date.setMilliseconds(this.timeLeft)
        return date.toISOString().substr(14, 5)
      }
    },
    mounted () {
      this.startCountdown()
    },
    beforeDestroy () {
      this.stopCountdown()
    },
    methods: {
      startCountdown () {
        this.timer = setInterval(this.count, 1000)
      },
      stopCountdown () {
        clearInterval(this.timer)
      },
      count () {
        this.timeLeft -= 1000

        if (this.timeLeft <= 0) {
          this.timeLeft = 0
          this.stopCountdown()
        }
      }
    }
  }
</script>
